<template>
    <Head>
        <title>OCP: Referrals</title>
    </Head>

    <authenticated-layout :notifications="notifications" >

        <div v-if="success && result" class="flex flex-col relative p-4 gap-4">
            <div class="flex flex-col bg-white rounded p-6 gap-6">
                <div class="grid grid-cols-2 border-b pb-6">
                    <div class="flex flex-col items-center">
                        <v-label>Reward base percent</v-label>
                        <span class="text-2xl">{{result.rewardBasePercent}}</span>
                    </div>
                    <div class="flex flex-col items-center">
                        <v-label>Reward Day</v-label>
                        <span class="text-2xl">{{ result.rewardDay }}</span>
                    </div>
                </div>
                <div class="grid grid-cols-4">
                    <div class="flex flex-col items-center">
                        <v-label>Total active</v-label>
                        <span class="text-2xl">{{result.totalActiveBalance}}</span>
                    </div>
                    <div class="flex flex-col items-center">
                        <v-label>Total frozen</v-label>
                        <span class="text-2xl">{{result.totalFrozenBalance}}</span>
                    </div>
                    <div class="flex flex-col items-center">
                        <v-label>Total reward</v-label>
                        <span class="text-2xl">{{result.totalRewardBalance}}</span>
                    </div>
                    <div class="flex flex-col items-center">
                        <v-label>Total reward + buffer</v-label>
                        <span class="text-2xl">{{result.totalRewardPlusBuffer}}</span>
                    </div>
                </div>
            </div>

            <div class="flex flex-col bg-white rounded p-4">
                <h2 class="text-lg font-bold">Address</h2>
                <div class="grid grid-cols-11 border-b p-2 gap-2 font-bold">
                    <span class="col-span-2">id</span>
                    <span class="col-span-2">address</span>
                    <span>tag</span>
                    <span>type</span>
                    <span>until</span>
                    <span class="text-center">coin</span>
                    <span class="text-center">network</span>
                    <span class="text-right">balance</span>
                    <span class="text-right">user balance</span>
                </div>
                <div class="grid grid-cols-11 p-2 gap-2">
                    <span class="col-span-2">{{ result.address.id }}</span>
                    <span class="col-span-2">{{ result.address.address }}</span>
                    <span>{{ result.address.tag }}</span>
                    <span>{{ result.address.type }}</span>
                    <span>{{ result.address.until }}</span>
                    <span class="text-center">{{ result.address.currencyName }}</span>
                    <span class="text-center">{{ result.address.networkName }}</span>
                    <span class="text-right">{{ result.address.balance }}</span>
                    <span class="text-right">{{ result.address.userBalance }}</span>
                </div>
            </div>

            <div class="flex flex-col bg-white rounded p-4">
                <h2 class="text-lg font-bold pb-2">Рефоводы</h2>
                <div class="grid grid-cols-10 p-2 gap-2 items-end font-bold sticky left-0 top-0 right-0 bg-white">
                    <strong class="col-span-2">Email</strong>
                    <strong class="text-center">Рефералов</strong>
                    <strong class="text-right">Баланс</strong>
                    <strong class="text-center">Процент</strong>
                    <strong class="col-span-2">Код</strong>
                    <div class="text-center">Создан <span class="text-sm text-gray-700">(UTC)</span></div>
                    <div class="text-center">Обновлен <span class="text-sm text-gray-700">(UTC)</span></div>
                </div>
                <div class="grid grid-cols-10 border-t items-center p-2 gap-2" v-for="ref of result.referrals">
                    <span class="col-span-2">{{ ref.userEmail }}</span>
                    <strong class="text-center">{{ ref.count }}</strong>
                    <strong class="text-right">{{ ref.balance }}</strong>
                    <span class="text-center">{{ ref.percent }}%</span>
                    <span class="col-span-2 text-sm">{{ ref.code }}</span>
                    <span class="text-center text-sm">{{ moment(ref.created).utc().format('L LTS') }}</span>
                    <span class="text-center text-sm">{{ moment(ref.updated).utc().format('L LTS') }}</span>
                    <Link class="text-gray-500 hover:text-blue-500 text-center" :href="route('user.referrals', ref.userId)">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mx-auto fill-current" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </Link>
                </div>
            </div>
        </div>

    </authenticated-layout>

</template>

<script>
import moment from "moment";
import {Head, Link} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VInput from "@/Components/Input";
import VButton from "@/Components/Button";
import VLabel from "@/Components/Label";

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
        VInput,
        VButton,
        VLabel,
    },
    props: {
        success: Boolean,
        result: Object,
        notifications: Object,
    },
    methods: {
        moment,
    },
}
</script>
